/**
 * Grid, zoom, and snap constants for the GenieCanvas.
 * Extracted from GenieCanvas.tsx.
 */

export const GRID_SIZE = 20
export const DOT_SIZE = 1.2
export const MIN_ZOOM = 0.33
export const MAX_ZOOM = 2.0
export const SNAP_GRID: [number, number] = [GRID_SIZE, GRID_SIZE]
